import { Module } from 'lib/vendor/terrific/Module';
import { Hook } from 'lib/vendor/terrific/Sandbox';

import { fetcher } from 'lib/util/helpers';

import { getProfile } from 'lib/personalization/profile';

import { loadDOCPProductMapping, Product, mapFlavours, xsrfHeader } from './skins/DOCPCheckout';
import { CurrentSelection } from './Tc.Module.LegoContainer';

export default class WBCOrderButton extends Module {
	private button! : HTMLInputElement;
	private mapping! : Promise<Record<string, Product>>;
	private products? : CurrentSelection;

	private isProcessing = false;

	public on(callback : Hook) {
		this.log.debug('on');
		this.button = this.$ctx.find('> sdx-button')[0] as any;
		this.button.disabled = true;
		callback();
	}

	public after() {
		this.log.debug('after');
		this.mapping = loadDOCPProductMapping();
		this.button.addEventListener('click', this.clicked.bind(this), false);
	}

	private async clicked(event : MouseEvent) {
		event.preventDefault();
		const products = this.products;
		if(!products || this.isProcessing) {
			this.log.warn('No products yet');

			return;
		}
		this.log.debug('Clicked WBC Order button with', products);
		this.button.disabled = true;
		this.isProcessing = true;
		const mapping = await this.mapping;
		const flavours = mapFlavours(mapping, products, this);
		try {
			const url = await urlToWbc(
				flavours,
				`${window.location.pathname}${window.location.search}${window.location.hash}`,
			);
			window.location.href = url;
		} catch(e) {
			this.log.error('Couldn’t get URL to WBC', e);
			this.isProcessing = false;
			this.button.disabled = false;
		}
	}

	/**
	 * Terrific Handler, fired by Tc.Module.LegoContainer.Configurator.
	 * Collects all selected product IDs and prepares the parameters needed for the order button URLs.
	 */
	public onNewLegoConfiguration({currentSelection} : {currentSelection : CurrentSelection}) {
		this.products = currentSelection;
		if(!this.isProcessing) {
			this.button.disabled = false;
		}
	}
}

const PES_URL = '/oce/soe/wbc/common/v1/input';

async function urlToWbc(flavours : Record<string, Product | undefined>, returnUrl : string) {
	const payload = {
		bundleSkuCode: 'LEGO_Home',
		cancelUrl: returnUrl,
		internetFlavourSkuCode: flavours.internetFlavour?.skuCode ?? null,
		returnUrl,
		tvFlavourSkuCode: flavours.tvFlavour?.skuCode ?? null,
		u26: false,
		uiLanguage: document.documentElement.lang,
		voipFlavourSkuCode: flavours.voipFlavour?.skuCode ?? null,
	};

	const fetch = await fetcher();
	const response = await fetch(PES_URL, {
		body: JSON.stringify(payload),
		headers: {
			consumer: 'OCE',
			'content-type': 'application/json',
			...xsrfHeader(),
		},
		method: 'POST',
	});

	const body = await response.json();
	const exchangeId = body.exchangeId;
	if(!exchangeId && /\bdevconsole\b/.test(window.location.href)) {
		console.error('Did not get an exchange ID back from', PES_URL, 'instead got', body);
	}

	// Add login param unless logged-in
	const profile = await getProfile();

	return `/bundle-configurator/?${profile.getUser() ? '' : 'login&'}${exchangeId ? 'exchangeId=' + exchangeId : ''}`;
}




// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/ecommerce/lego/Tc.Module.WBCOrderButton.ts